export const TaxIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2891 20.8828H5.22656C5.03594 20.8828 4.85312 20.8071 4.71833 20.6723C4.58354 20.5375 4.50781 20.3547 4.50781 20.1641V7.22656C4.50781 7.03594 4.58354 6.85312 4.71833 6.71833C4.85312 6.58354 5.03594 6.50781 5.22656 6.50781H12.4141L16.0078 10.1016V20.1641C16.0078 20.3547 15.9321 20.5375 15.7973 20.6723C15.6625 20.8071 15.4797 20.8828 15.2891 20.8828Z"
      stroke="currentColor"
      strokeWidth="1.79688"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.38281 6.50781V4.35156C7.38281 4.16094 7.45857 3.97812 7.59333 3.84333C7.7281 3.70854 7.91095 3.63281 8.10156 3.63281H15.2891L18.8828 7.22656V17.2891C18.8828 17.4797 18.8071 17.6625 18.6723 17.7973C18.5375 17.9321 18.3547 18.0078 18.1641 18.0078H16.0078"
      stroke="currentColor"
      strokeWidth="1.79688"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.10156 14.4141H12.4141"
      stroke="currentColor"
      strokeWidth="1.79688"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.10156 17.2891H12.4141"
      stroke="currentColor"
      strokeWidth="1.79688"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
